module.exports = __webpack_public_path__ + "img/01.29bf49c4.png";